import type { JSX } from "solid-js";
import { useNavigate } from "@tanstack/solid-router";

type Props = {
  eventTitle: string;
  label: string;
  trailing?: JSX.Element;
};

export function EventPageHeader(props: Props) {
  const navigate = useNavigate();

  return (
    <header class="event-page-header">
      <div class="event-page-header-brand">
        <div class="event-page-header-titles">
          <strong>{props.eventTitle}</strong>
          <span class="status-chip">{props.label}</span>
        </div>
      </div>
      <div class="event-page-header-actions">
        <button
          type="button"
          class="btn btn-outline btn-sm"
          aria-label="Switch conference"
          onClick={() => navigate({ to: "/" })}
        >
          Switch
        </button>
        {props.trailing}
      </div>
    </header>
  );
}
